// extracted by mini-css-extract-plugin
export default {"row":"WizardTracker_row__yt3pJ","progress":"WizardTracker_progress__Yv5QH","illustration":"WizardTracker_illustration__rxKTj","checkIcon":"WizardTracker_checkIcon__Wd3eW"};